module.exports = __webpack_public_path__ + "img/bb_g3_arm-01.70d047b7.svg";